import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

export interface RunTemplatePickerOption {
  id: string
  label: string
  description: string
}

interface RunTemplatePickerProps {
  disabled?: boolean
  id: string
  options: RunTemplatePickerOption[]
  value: string
  onValueChange: (value: string) => void
}

export function RunTemplatePicker({
  disabled = false,
  id,
  options,
  value,
  onValueChange,
}: RunTemplatePickerProps) {
  const hasOptions = options.length > 0
  const selectedOption = options.find((option) => option.id === value)
  const labelId = `${id}-label`
  const descriptionId = `${id}-description`

  return (
    <div>
      <Select
        value={value}
        onValueChange={onValueChange}
        disabled={disabled || !hasOptions}
      >
        <SelectTrigger
          id={id}
          variant="secondary"
          className="h-auto min-h-[72px] bg-coval-surface-raised p-3 text-left hover:bg-coval-surface-raised"
          aria-labelledby={labelId}
          aria-describedby={
            selectedOption?.description ? descriptionId : undefined
          }
        >
          <span className="flex min-w-0 flex-1 flex-col">
            <span
              id={labelId}
              className="text-xs font-medium uppercase tracking-wide text-coval-text-muted"
            >
              Template
            </span>
            <span className="mt-1 truncate text-sm font-medium text-coval-text">
              <SelectValue
                placeholder={
                  hasOptions ? "Select a template" : "No templates available"
                }
              />
            </span>
            {selectedOption?.description && (
              <span
                id={descriptionId}
                className="mt-1 truncate text-xs font-normal text-coval-text-muted"
              >
                {selectedOption.description}
              </span>
            )}
          </span>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem
              key={option.id}
              value={option.id}
              description={option.description || undefined}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
